<template>
  <div>
    <swiper
      class="st-swiper"
      ref="swiper"
      :options="swiperOptions"
      v-bind:class="{ disabled: isProduct, 'st-swiper-product': isProduct }"
    >
      <slot />
    </swiper>
    <div
      class="swiper-button-prev"
      slot="button-prev"
      v-bind:class="{ disabled: isProduct }"
    ></div>
    <div
      class="swiper-button-next"
      slot="button-next"
      v-bind:class="{ disabled: isProduct }"
    ></div>
  </div>
</template>

<script>
import "swiper/swiper-bundle.css";
import { EventBus } from "../event-bus.js";
export default {
  //https://github.com/surmon-china/vue-awesome-swiper
  name: "SwiperContent",
  props: {
    isProduct: Boolean,
  },
  data: function () {
    return {
      swiperOptions: {
        watchOverflow: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
          disabledClass: "swiper-button-disabled",
          hiddenClass: "swiper-button-hidden",
          hideOnClick: false,
          preventClicks: false,
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.swiper.$swiper;
    },
  },
  mounted: function () {
    this.swiper.navigation.update();
    this.swiper.update();
    EventBus.$on("resize", this.resize);
  },
  beforeDestroy: function () {
    EventBus.$off("resize", this.resize);
  },
  methods: {
    resize() {
      if (this.swiper.navigation) {
        this.swiper.navigation.update();
        this.swiper.update();
      }
    },
  },
};
</script>

<style scoped></style>
